import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.tiny};
  `}

  ${media.sm`
    flex-direction: row;
    margin-bottom: 0;
  `}
`
